import type { CompanyMembersQueryDTO } from '@shared/schemas/organization';
import type { CompanyMembersScope } from './company-api';

export const defaultCompanyMembersQuery: CompanyMembersQueryDTO = {
  page: 1,
  pageSize: 20,
  role: 'all',
  search: undefined,
  sortBy: 'createdAt',
  sortDirection: 'desc',
  status: 'all',
  verification: 'all',
};

function scopeKey(scope: CompanyMembersScope) {
  return scope.type === 'targeted' ? `targeted:${scope.companyId}` : 'active';
}

export const companyMembersQueryKeys = {
  all: ['company-members'] as const,
  lists: (scope: CompanyMembersScope) => [
    ...companyMembersQueryKeys.all,
    scopeKey(scope),
    'list',
  ] as const,
  list: (scope: CompanyMembersScope, query: CompanyMembersQueryDTO) => [
    ...companyMembersQueryKeys.lists(scope),
    query,
  ] as const,
};
